module.exports = __webpack_public_path__ + "media/images/ac_templates/201/gin-a4797aae93027a43afe959a5290525f1.jpg";